var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-failed"},[_c('i',{staticClass:"mdi mdi-alert-circle ta--text-error"}),_c('p',{staticClass:"error-title"},[_vm._v("登录失败，请尝试刷新页面")]),(_vm.$store.state.errMsg)?_c('p',{staticClass:"error-desc"},[_vm._v(_vm._s(_vm.$store.state.errMsg))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }